import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CognitoUser} from "../../../models";

export interface FnolSearchCriteria {
  progress: string;
  assignee: string;
  fnolFirstName: string;
  fnolLastName: string;
  fnolEmail: string;
  fnolPetName: string;
  firstDate: string;
  lastDate: string;
  oldestFirst: boolean;
  priority: number | undefined;
}


@Component({
  selector: 'CPF-fnol-request-find',
  templateUrl: './fnol-request-find.component.html',
  styleUrls: ['./fnol-request-find.component.scss']
})
export class FnolRequestFindComponent {
  public search: FnolSearchCriteria = {
    progress: '',
    assignee: '',
    fnolFirstName: '',
    fnolLastName: '',
    fnolEmail: '',
    fnolPetName: '',
    firstDate: '',
    lastDate: '',
    oldestFirst: false,
    priority: undefined
  }

  public users: CognitoUser[] = [];

  constructor(public dialogRef: MatDialogRef<FnolRequestFindComponent>, @Inject(MAT_DIALOG_DATA) public data: { users: CognitoUser[], search: FnolSearchCriteria
  }) {
    this.users = data.users;
    this.search = data.search;
  }

  searchFnolRequests() {
    this.dialogRef.close(this.search);
  }

  clearAll() {
    this.search = {
      progress: '',
      assignee: '',
      fnolFirstName: '',
      fnolLastName: '',
      fnolEmail: '',
      fnolPetName: '',
      firstDate: '',
      lastDate: '',
      oldestFirst: false,
      priority: undefined,
    }
  }

  // Trim whitespace from beginning and end of input fields
  onFirstNameInput(event: any) {
    this.search.fnolFirstName = event.target.value.trim();
  }

  onLastNameInput(event: any) {
    this.search.fnolLastName = event.target.value.trim();
  }

  onEmailInput(event: any) {
    this.search.fnolEmail = event.target.value.trim();
  }

  onPetNameInput(event: any) {
    this.search.fnolPetName = event.target.value.trim();
  }
}
